// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';
import configs from '../../../conf';

const config = configs[process.env.NODE_ENV];
export default class FirebaseFeature {
  constructor() {
    this.app = null;
    this.analytics = null;
  }

  // Initialize Firebase
  static initializeFirebase() {
    if (!this.app) {
      this.app = initializeApp(config.firebaseConfig);
      this.analytics = getAnalytics(this.app);

      let user = JSON.parse(localStorage.getItem('userDetails'));
      if (user) {
        setUserProperties(this.analytics, { company: user.companyId });
      }
    }
  }

  static async turnOffFirebase() {
    try {
      await this.app.delete();
    } catch (e) {
      console.log('Firebase disablling error', e);
    }
  }
}
